import { memo } from 'react';
import styled from 'styled-components';
import { Badge } from 'foundations-components/transitional/components/Badge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InlineFlexLabel = styled.div.withConfig({
  displayName: "CampaignsPlatformSelectLabel__InlineFlexLabel"
})(["display:inline-flex;align-items:center;flex-direction:row;"]);
function CampaignsPlatformSelectLabel({
  associationSettings,
  objectType
}) {
  const {
    hasBetaBadge,
    hasNewBadge
  } = associationSettings[objectType].campaignsAssociations.metadata;
  const hasBadge = (hasBetaBadge === null || hasBetaBadge === void 0 ? void 0 : hasBetaBadge.value) || (hasNewBadge === null || hasNewBadge === void 0 ? void 0 : hasNewBadge.value);
  return /*#__PURE__*/_jsxs(InlineFlexLabel, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaignSelect.formEditorControlLabel"
    }), hasBadge && /*#__PURE__*/_jsx(Badge, {
      use: hasBetaBadge !== null && hasBetaBadge !== void 0 && hasBetaBadge.value ? 'beta' : 'new',
      marginInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `campaignSelect.${hasBetaBadge !== null && hasBetaBadge !== void 0 && hasBetaBadge.value ? 'beta' : 'new'}`
      })
    })]
  });
}
export default /*#__PURE__*/memo(CampaignsPlatformSelectLabel);